import { FC, useState } from 'react';

import { router } from '@inertiajs/react';

import { Button } from '../../../../components/ui/Button';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '../../../../components/ui/Dialog';
import { Input } from '../../../../components/ui/Input';
import { Label } from '../../../../components/ui/Label';
import { Textarea } from '../../../../components/ui/Textarea';
import { Routes } from '../../../../models/routes';

interface Props {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    defaultName?: string;
    onSuccess?: () => void;
}

export const ProductProposalModal: FC<Props> = ({
    open,
    onOpenChange,
    defaultName,
    onSuccess,
}) => {
    const [name, setName] = useState(defaultName);
    const [info, setInfo] = useState('');

    const handleSubmit = () => {
        router.post(
            Routes.ProductProposals,
            {
                product_proposal: {
                    name: name,
                    additional_info: info,
                },
            },
            {
                onSuccess: () => {
                    onOpenChange(false);
                    if (onSuccess) onSuccess();
                },
            },
        );
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="w-[95vw] max-w-[425px] border-input sm:w-full">
                <DialogHeader>
                    <DialogTitle>Запропонувати товар</DialogTitle>
                    <DialogDescription>
                        Якщо ви не знайшли потрібний товар, ви можете
                        запропонувати його додання в нашу базу.
                    </DialogDescription>
                </DialogHeader>
                <div className="grid gap-4 py-4">
                    <div className="grid gap-2">
                        <Label htmlFor="name">Назва товару</Label>
                        <Input
                            id="name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="Введіть назву товару"
                        />
                    </div>
                    <div className="grid gap-2">
                        <Label htmlFor="info">Додаткова інформація</Label>
                        <Textarea
                            id="info"
                            value={info}
                            onChange={(e) => setInfo(e.target.value)}
                            placeholder="Посилання, опис або будь-яка інша корисна інформація..."
                            className="min-h-[100px]"
                        />
                    </div>
                </div>
                <DialogFooter className="flex-col gap-2 sm:flex-row sm:gap-0">
                    <Button
                        variant="outline"
                        onClick={() => onOpenChange(false)}
                        className="mt-2 w-full sm:mt-0 sm:w-auto"
                    >
                        Скасувати
                    </Button>
                    <Button onClick={handleSubmit} className="w-full sm:w-auto">
                        Надіслати пропозицію
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};
